exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".titleandtool_style_listitem__2Gvrz {\n  display: inline-flex;\n  width: 100%;\n  align-items: center;\n  justify-content: flex-start; }\n\n.titleandtool_style_popup_content__QxXJw {\n  padding: 24px; }\n\n.titleandtool_style_detail_function_button_area__2s0cl {\n  width: 100%;\n  margin-top: 12px;\n  display: inline-flex;\n  justify-content: center; }\n", ""]);

// exports
exports.locals = {
	"listitem": "titleandtool_style_listitem__2Gvrz",
	"popup_content": "titleandtool_style_popup_content__QxXJw",
	"detail_function_button_area": "titleandtool_style_detail_function_button_area__2s0cl"
};